export default "__VITE_ASSET__ab211233__"